import { CHANGE_SELECTED_TASKS } from '../actions/select_list';

export default function (state = {}, action) {
  switch (action.type) {
  case CHANGE_SELECTED_TASKS:
    return { ...state, selectedTaskIds: action.tasks };
  default:
    return state;
  }
}
